module.exports = __webpack_public_path__ + "static/media/Brands_25.7413037b.png";